export const singleWorkstationsConstants = {
    ADD_ITEMS: '[SingleWorkstations] Add Item',
    UPDATE: '[SingleWorkstations] Update Item',
    REMOVE: '[SingleWorkstations] Remove Item',
    AJAX_CALL_FAILURE: '[SingleWorkstations] Ajax call failed',
}
